module.exports = __webpack_public_path__ + "assets/img/34_774_big.6c87d59b.jpg";